import { z } from '@hono/zod-openapi'

export const ApiSuccessResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    success: z.literal(true),
    data: dataSchema,
  }).openapi('ApiSuccessResponse')

export const ApiErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string().openapi({ example: 'Resource not found' }),
  code: z.string().openapi({ example: 'NOT_FOUND' }),
  details: z.unknown().nullable(),
}).openapi('ApiErrorResponse')

export const PaginationParamsSchema = z.object({
  page: z.coerce.number().int().min(1).default(1).openapi({ example: 1 }),
  pageSize: z.coerce.number().int().min(1).max(100).default(50).openapi({ example: 50 }),
}).openapi('PaginationParams')

export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    data: z.array(itemSchema),
    total: z.number().int().openapi({ example: 142 }),
    page: z.number().int().openapi({ example: 1 }),
    pageSize: z.number().int().openapi({ example: 50 }),
  }).openapi('PaginatedResponse')

export const IdParamSchema = z.object({
  id: z.string().uuid().openapi({ example: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890' }),
})

export const DistrictParamSchema = z.object({
  districtId: z.string().min(1).max(64).openapi({ example: 'dist-wa-12345' }),
})

export const DateRangeSchema = z.object({
  from: z.string().datetime().nullable(),
  to: z.string().datetime().nullable(),
}).openapi('DateRange')

export type PaginationParams = z.infer<typeof PaginationParamsSchema>
